
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Projects', href: '/projects' },
    { name: 'Contact Us', href: '/contact' },
    { name: 'Timesheet', href: 'https://us-timesheet-management.vercel.app/', external: true }
  ];

  const navLinkClass = (href: string, isMobile = false) => {
    const isActive = !isMobile && location.pathname === href;
    if (isMobile) {
      return `block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 cursor-pointer ${
        isActive
          ? 'text-teal-600 bg-teal-50'
          : 'text-slate-700 hover:text-teal-600 hover:bg-slate-50'
      }`;
    }
    return `text-sm font-medium transition-colors duration-200 cursor-pointer ${
      isActive ? 'text-teal-600' : 'text-slate-700 hover:text-teal-600'
    }`;
  };

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link 
              to="/" 
              onClick={handleLinkClick}
              className="cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/7fe129f8d7ac12cdc97a659d50dae110/fa42b0a376449b5dcc83f587cf78b734.png" 
                alt="Mitaja Corporation" 
                className="h-16 w-auto"
              />
            </Link>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) =>
              item.external ? (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={navLinkClass(item.href)}
                >
                  {item.name}
                </a>
              ) : (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={handleLinkClick}
                  className={navLinkClass(item.href)}
                >
                  {item.name}
                </Link>
              )
            )}
          </nav>

          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-slate-600 hover:text-slate-900 p-2 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                {isMobileMenuOpen ? (
                  <i className="ri-close-line text-xl"></i>
                ) : (
                  <i className="ri-menu-line text-xl"></i>
                )}
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navigation.map((item) =>
              item.external ? (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleLinkClick}
                  className={navLinkClass(item.href, true)}
                >
                  {item.name}
                </a>
              ) : (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={handleLinkClick}
                  className={navLinkClass(item.href, true)}
                >
                  {item.name}
                </Link>
              )
            )}
          </div>
        </div>
      )}
    </header>
  );
}
